<script lang="ts">
export interface ProseH5Props {
  id?: string
  class?: any
}

export interface ProseH5Slots {
  default: (props?: object) => unknown
}
</script>

<script setup lang="ts">
const props = defineProps<ProseH5Props>()
defineSlots<ProseH5Slots>()
</script>

<template>
  <h5
    :id
    class="my-1 text-base font-semibold"
    :class="props.class"
  >
    <slot />
  </h5>
</template>
